import './Info.css'
import InfoBreakout from './InfoBreakout'
import { Row, Col } from 'antd';
import { FormattedData } from './financialsModel'

export type Props = { data: FormattedData['info'] }

export default function Info({ data }: Props) {
  return (
    <Row gutter={7}>
      <Col span={8} style={{ display: 'flex' }}>
        <InfoBreakout title="Revenue" data={data.price} />
      </Col>
      <Col span={8} style={{ display: 'flex' }}>
        <InfoBreakout title="Gross Profit" data={data.grossProfit} />
      </Col>
      <Col span={8} style={{ display: 'flex' }}>
        <InfoBreakout title="Net Profit" data={data.netProfit} />
      </Col>
    </Row>
  );
}
